module.exports = __webpack_public_path__ + "static/media/001_ar_01.ca3f0ce6.mp4";